export class MesureAdductionDTO {
    code!: string;
    date!: Date;
    localisation!: string;
    samplingId!: number;
    observation!: string;
    appareilMesure!: string;

}